<template>
  <div class="editor-title">
    <h4>{{ t("message.bargraphHeader") }}</h4>
  </div>

  <ul>
    <template v-if="!currentInlay.name.includes('gt6l')">
      <li class="editor-element">
        <!-- <input type="checkbox" checked />
        <i class="arrow"></i> -->
        <h2 class="text-start row mb-3">
          <div class="col-5">{{ t("message.barGrLEDs") }}</div>
          <div class="col-7">
            <button class="btn btn-outline-lcn" @click="toggleBarG">
              <font-awesome-icon
                :icon="['far', showBarG ? 'eye-slash' : 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{ showBarG ? t("message.fadeOut") : t("message.fadeIn") }}
            </button>
          </div>
        </h2>
        <div class="content-expand">
          <template v-if="showBarG">
            <div class="col-7 offset-5">
              <label
                class="p-2 pb-1"
                for="bargraph"
                @click="changeBarGraph('BargraphLED')"
                style="cursor: pointer"
                :style="{
                  'border-bottom':
                    currentInlay.inlay.selectedBarGType == 'BargraphLED'
                      ? '1px solid #ffee00'
                      : '',
                }"
              >
                {{ t("message.separate") }}
              </label>
              <input
                class="bargraph-select"
                type="checkbox"
                name="bargraph"
                id="bargraph"
              />
              <label
                for="bargraph"
                class="p-1 pb-1"
                @click="changeBarGraph('BargraphLEDgrad')"
                style="cursor: pointer"
                :style="{
                  'border-bottom':
                    currentInlay.inlay.selectedBarGType == 'BargraphLEDgrad'
                      ? '1px solid #ffee00'
                      : '',
                }"
                >{{ t("message.continuous") }}</label
              >
              <input
                class="bargraph-select"
                type="checkbox"
                name="bargraph"
                id="bargraph"
              />
            </div>
            <div class="row mt-3 text-start">
              <div class="col-5">{{ t("message.colorSamples") }}</div>
              <div class="col-7">
                <img
                  src="@/assets/images/leds/blueredgrad.png"
                  alt=""
                  style="
                    border: 1px solid grey;
                    margin-right: 5px;
                    cursor: pointer;
                  "
                  @click="colorBarG('bluered')"
                />
                <img
                  src="@/assets/images/leds/greygreengrad.png"
                  alt=""
                  style="
                    border: 1px solid grey;
                    margin-right: 5px;
                    cursor: pointer;
                  "
                  @click="colorBarG('greygreen')"
                />
                <img
                  src="@/assets/images/leds/greyyellowgrad.png"
                  @click="colorBarG('greyyellow')"
                  alt=""
                  style="
                    border: 1px solid grey;
                    margin-right: 5px;
                    cursor: pointer;
                  "
                />
                <img
                  src="@/assets/images/leds/white.png"
                  alt=""
                  style="border: 1px solid grey; cursor: pointer"
                  @click="colorBarG('white')"
                />
              </div>
            </div>
            <div class="mt-3 mb-2">
              <div class="row text-start">
                <div class="col-5">{{ t("message.color") }}</div>
                <div class="col-7">
                  <transition name="fade">
                    <button
                      class="btn btn-outline-lcn"
                      @click="showPicker = true"
                      v-if="!showPicker"
                    >
                      <font-awesome-icon
                        :icon="['far', 'eye']"
                        class="icon"
                      ></font-awesome-icon>
                      {{ t("message.fadeIn") }}
                    </button>
                  </transition>
                </div>
              </div>
              <div>
                <transition name="fade">
                  <div v-if="showPicker">
                    <div class="color-picker-container">
                      <MyCp
                        @update="updateColor($event)"
                        @mouseup="mouseUp"
                        :id="'color-picker-inlaybg'"
                        :pColor="{
                          type: 'solid',
                          color:
                            selectedBarGLEDs.length > 0 &&
                            currentBargraph[selectedBarGLEDs[0].id].style[
                              'background-color'
                            ] !== 'white'
                              ? currentBargraph[selectedBarGLEDs[0].id].style[
                                  'background-color'
                                ]
                              : '',
                        }"
                      ></MyCp>
                    </div>
                    <div class="mt-3">
                      <button
                        class="btn btn-outline-lcn me-2"
                        @click="updateBtn('background-color', '')"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'ban']"
                          class="icon"
                        ></font-awesome-icon>
                        {{ t("message.colorRemove") }}
                      </button>
                      <button
                        class="btn btn-outline-lcn"
                        @click="showPicker = false"
                      >
                        <font-awesome-icon
                          :icon="['far', 'eye-slash']"
                          class="icon"
                        ></font-awesome-icon>
                        {{ t("message.fadeOut") }}
                      </button>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </template>
        </div>
      </li>
      <li class="topic-separator">
        <h2 class="text-start row mb-3 mt-2">
          <div class="col-5">
            {{ t("message.caption") }}
          </div>
          <div class="col-7 text-start">
            <button class="btn btn-outline-lcn" @click="displayBarGCaption()">
              <font-awesome-icon
                :icon="[
                  'far',
                  currentInlay.inlay.showBargraphCaptions ? 'eye-slash' : 'eye',
                ]"
                class="icon"
              ></font-awesome-icon>
              {{
                currentInlay.inlay.showBargraphCaptions
                  ? t("message.fadeOut")
                  : t("message.fadeIn")
              }}
            </button>
          </div>
        </h2>
        <div class="content-expand">
          <template v-if="currentInlay.inlay.showBargraphCaptions">
            <div class="row text-start">
              <div class="col-5">Basiswert</div>
              <div class="col-5 mb-2">
                <input
                  type="number"
                  class="form-control"
                  @input="updateBargraphCaption($event)"
                  :value="bargraphCaptionBase"
                  min="0"
                />
              </div>
            </div>
            <div class="row text-start">
              <div class="col-5">Schrittweite</div>
              <div class="col-5">
                <input
                  type="number"
                  class="form-control"
                  @input="updateBargraphCaption($event, 'step')"
                  :value="bargraphCaptionStep"
                  min="0"
                  step="0.1"
                />
              </div>
            </div>
          </template>
          <template v-if="currentInlay.inlay.showBargraphCaptions">
            <div class="row mb-3 mt-3 text-start">
              <div class="col-5">Position</div>
              <div class="col-7">
                <button
                  class="btn btn-outline-lcn"
                  :class="{ active: !currentInlay.inlay.bargraphCaptionsRight }"
                  @click="displayBarGCaptionLeftUp()"
                >
                  {{
                    currentInlay.inlay.style.horizontal
                      ? t("message.bargraphCUp")
                      : t("message.bargraphCLeft")
                  }}
                </button>
                <button
                  class="btn btn-outline-lcn ms-3"
                  :class="{ active: currentInlay.inlay.bargraphCaptionsRight }"
                  @click="displayBarGCaptionRightDown()"
                >
                  {{
                    currentInlay.inlay.style.horizontal
                      ? t("message.bargraphCDown")
                      : t("message.bargraphCRight")
                  }}
                </button>
              </div>
            </div>
          </template>
          <div class="row pb-2" v-if="currentInlay.inlay.showBargraphCaptions">
            <div class="col-5 text-start">
              {{ t("message.color") }}
            </div>
            <div class="col-7">
              <div class="row px-2">
                <div
                  class="col-1 swatch-el"
                  v-for="(color, index) in swatchColors"
                  :key="'color_' + index"
                  :style="{ 'background-color': color }"
                  @click="switchBarGCaptionColor(color)"
                ></div>
                <div
                  class="col-1 swatch-el"
                  @click="switchBarGCaptionColor('#ffffff')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import MyCp from "@/views/editors/editor-components/ColorPicker.vue";
export default {
  components: {
    MyCp,
  },
  setup() {
    const store = useStore();
    const showBarG = computed(() => store.getters.showBarG);
    const currentInlay = computed(() => store.getters.currentInlay);
    const currentBargraph = computed(() => store.getters.selectedBarG);
    const selectedBarGLEDs = computed(() => store.getters.selectedBarGLEDs);
    const smallKeys = computed(() => store.getters.smallKeys);
    const showPicker = ref(false);
    const showBarGCaptions = computed(() => store.getters.showBargraphCaptions);
    const { t } = useI18n();
    const bargraphCaptionStep = ref(2.0);
    const bargraphCaptionBase = ref(14);
    const swatchColors = [
      "#ff0000",
      "#E75F6B",
      "#e91e63",
      "#A46422",
      "#ff9800",
      "#ffff00",
      "#4CAF50",
      "#8bc34a",
      "#87ceeb",
      "#0000ff",
      "#a22cff",
      "#f1f1f1",
      "#000000",
    ];

    function toggleBarG() {
      if (smallKeys.value) {
        let revert = confirm(t("message.revertKeys"));
        if (revert) {
          store.commit("setRevertKeys", {
            group: currentInlay.value.group,
            name: currentInlay.value.name,
          });
        }
        store.commit("setSmallKeys", false);
      }
      store.dispatch("toggleBarG", !showBarG.value);
      store.commit("setSelectedBarGLEDsEmpty");
    }
    function changeBarGraph(graph) {
      store.dispatch("selectBarG", graph);
    }
    function updateColor(event) {
      selectedBarGLEDs.value.forEach((led) => {
        let ledIdx = currentInlay.value.inlay.bargraph.findIndex(
          (bled) => led.id == bled.id
        );
        let selIdx = currentBargraph.value.findIndex(
          (selLed) => led.id == selLed.id
        );
        store.dispatch("changeBargraphColor", {
          index: ledIdx,
          color: event.colors.hex,
        });
        currentBargraph.value[selIdx].style["background-color"] =
          event.colors.hex;
      });
    }
    function colorBarG(value) {
      let br = [
        "#FF0000",
        "#EB0813",
        "#E50A1A",
        "#CE1331",
        "#B31E4B",
        "#AB2155",
        "#8E2B71",
        "#7E3381",
        "#75258A",
        "#623D9D",
        "#4D45B2",
        "#3B4DC5",
        "#115DEE",
        "#095FF6",
        "#0363FD",
      ];
      let gg = [
        "#57FA2C",
        "#4FEE27",
        "#3FD51A",
        "#34C313",
        "#2BB40C",
        "#22A606",
        "#1C9B02",
        "#158E00",
        "#107B00",
        "#107100",
        "#106600",
        "#155C07",
        "#225418",
        "#3C493A",
        "#444544",
      ];
      let gy = [
        "#FEDD00",
        "#FBD600",
        "#F7CC00",
        "#ECBB00",
        "#E1B000",
        "#D7A701",
        "#CEA005",
        "#BE950C",
        "#B08B12",
        "#A08019",
        "#937820",
        "#79672C",
        "#6B573D",
        "#625838",
        "#454545",
      ];
      let colors = [];
      switch (value) {
        case "bluered":
          colors = br;
          break;
        case "greygreen":
          colors = gg;
          break;
        case "greyyellow":
          colors = gy;
          break;
      }
      currentBargraph.value.forEach((led, index) => {
        let ledIdx = currentInlay.value.inlay.bargraph.findIndex(
          (bled) => led.id == bled.id
        );
        let selIdx = currentBargraph.value.findIndex(
          (selLed) => led.id == selLed.id
        );

        if (value != "white") {
          store.dispatch("changeBargraphColor", {
            index: ledIdx,
            color: colors[index],
          });
          currentBargraph.value[selIdx].style["background-color"] =
            colors[index];
        } else {
          store.dispatch("changeBargraphColor", {
            index: ledIdx,
            color: "white",
          });
          currentBargraph.value[selIdx].style["background-color"] = "white";
        }
      });
    }
    function changeColor(e) {
      // updateBtn("background", e);
      //console.log(e);
    }
    function mouseUp() {
      store.dispatch("saveInlay");
    }
    function displayBarGCaption() {
      store.dispatch("toggleBarGCaptions", !showBarGCaptions.value);
    }
    function displayBarGCaptionLeftUp() {
      if (currentInlay.value.inlay.bargraphCaptionsRight)
        store.commit("setBarGCaptionsLeftUp");
    }
    function displayBarGCaptionRightDown() {
      if (!currentInlay.value.inlay.bargraphCaptionsRight)
        store.commit("setBarGCaptionsRightDown");
    }

    function switchBarGCaptionColor(color) {
      store.commit("setBarGCaptionColor", color);
      store.dispatch("saveInlay");
    }
    function updateBargraphCaption(event, trigger) {
      if (trigger === "step") {
        bargraphCaptionStep.value = event.target.value;
      } else {
        bargraphCaptionBase.value = event.target.value;
      }
      store.dispatch("setBargraphCaptions", {
        base: bargraphCaptionBase.value,
        step: bargraphCaptionStep.value,
      });
    }
    return {
      toggleBarG,
      showBarG,
      currentInlay,
      changeBarGraph,
      updateColor,
      currentBargraph,
      selectedBarGLEDs,
      showPicker,
      t,
      colorBarG,
      changeColor,
      mouseUp,
      displayBarGCaption,
      displayBarGCaptionLeftUp,
      displayBarGCaptionRightDown,
      switchBarGCaptionColor,
      updateBargraphCaption,
      bargraphCaptionStep,
      bargraphCaptionBase,
      swatchColors,
    };
  },
};
</script>

<style lang="scss" scoped>
.bargraph-select {
  height: 5px !important;
  display: none;
}
.active {
  background-color: #ffee00 !important;
  color: black !important;
}
.swatch-el,
.border-color {
  border: 1px solid grey;
  border-radius: 5px;
  height: 20px;
  width: 20px;
  margin: 3px;
  // margin-left: 15px;
  cursor: pointer;
}
</style>
